const league = [
	{
		side: "Home / Round 3",
		team: "West Ham United",
		result: "0-1",
		possession: "61 %",
		shots: 27,
		onTarget: 6,
		passes: 584,
		passesCompleted: 496,
		tackles: 7,
		aerial: 20,
	},
];

export default league